import React, { useState, useEffect, useRef } from "react";
import * as _ from "lodash";
import { Grid } from "@material-ui/core";
import "../AFReadyDisigen/invoiceprint.css"
import { stylePadding, stylePaddingFooter, stylePaddingHead } from "../ShareFunctionsPrint";
import HeaderAll from "../../HeaderAll";
import BodyInv from "../AFReadyDisigen/A4/BodyInv";
import UnderHeader from "./A4/UnderHeader";
import FooterM from "./A4/FooterM";
import { useInvAF } from "../../../St/Reviews/UseStyle";
import InvTotal from "../AFReadyDisigen/A4/InvTotal";

function HeadersNew(props) {
    const { found  } = props;
    return (
        <div style={stylePaddingHead}>
            <HeaderAll Report={false} found={found} />
        </div>
    );

}
function HeadersSecond(props) {
    const { locInv, found, sta, inv } = props;
    return (
        <div style={stylePadding}>
            <UnderHeader found={found} inv={inv} sta={sta} locInv={locInv} />
        </div>
    );
}
function BodyInvoice(props) {
    const { sta, inv, premiApp, chunk, locInv,isLast } = props;
    return (
        <div style={stylePadding}>
            <BodyInv
                data={chunk ?? []}
                isLast={isLast}
                inv={inv}
                sta={sta}
                locInv={locInv}
                premiApp={premiApp}
            />
        </div>
    );
}
function NotesFooter(props) {
    const { inv,num, premiApp, clas } = props;
    return (
        <div style={stylePadding}>
            {num!== 14 ? (
                <Grid item xs={12} className={clas.BdytotCntMmm} style={{ textAlign: "right" }}>
                    {inv.notes}
                </Grid>
            ) : null}
        </div>
    );
}
function Footers(props) {
    const { found, sta, num } = props;
    return (
        <div className="footerview" style={stylePaddingFooter}>
            <FooterM found={found} sta={sta} num={num} />
        </div>
    );
}


function MaintancInvCon(props) {
    const { locInv, found, sta, inv, data, premiApp } = props;
    const headerFirstRef = useRef(null);
    const headerSecondRef = useRef(null);
    const footerRef = useRef(null);
    const totalsref = useRef(null);
    const footerNotes = useRef(null);
    const clas = useInvAF();
    const rowrefs = useRef([]);
    const [pages, setPages] = useState([]);
    const num  = Number(locInv?.largeNum);


    useEffect(() => {
        const calcutepages = async () => {
            if (document.fonts) await document.fonts.ready;
            const PAGE_HEIGHT = 1120;
            const HEADER1 = headerFirstRef.current?.offsetHeight || 0;
            const HEADER2 = headerSecondRef.current?.offsetHeight || 0;
            const FOOTER1 = footerRef.current?.offsetHeight || 0;
            const totalsH = totalsref.current?.offsetHeight || 0;
            const FOOTERNOTESREF = footerNotes.current?.offsetHeight || 0;

            const max_Height = PAGE_HEIGHT - (HEADER1 + HEADER2 + FOOTER1 + FOOTERNOTESREF + 20);

            const heights = rowrefs.current.map(el => el?.offsetHeight || 0);

            let pageInvoice = [];
            let currentPage = [];
            let currentHeight = 0;

            data.forEach((item, i) => {
                const rowHieght = heights[i];
                if (currentHeight + rowHieght > max_Height) {
                    pageInvoice.push(currentPage);
                    currentPage = [];
                    currentHeight = 0;
                }
                currentPage.push(item);
                currentHeight += rowHieght;
            });

            if (currentHeight + totalsH > max_Height) {
                pageInvoice.push(currentPage);
                pageInvoice.push([]);
            } else {
                pageInvoice.push(currentPage);
            }
            setPages(pageInvoice);
        };
        calcutepages();
    }, [data]);


    return (
        <>
            <div className="measurecon" >
                <div ref={headerFirstRef}>
                    <HeadersNew found={found} />
                </div>
                <div ref={headerSecondRef}>
                    <HeadersSecond locInv={locInv} found={found} sta={sta} inv={inv} />
                </div>
                {data.map((item, i) => (
                    <div key={i}
                        ref={(el) => (rowrefs.current[i] = el)}
                        className="measurerow"
                    >
                        {item.symbol}
                    </div>
                ))}
                <div ref={footerNotes}>
                    <NotesFooter inv={inv} num={num} premiApp={premiApp} clas={clas} />
                </div>
                <div ref={totalsref}>
                    <InvTotal inv={inv} sta={sta} num={num} premiApp={premiApp}/>
                </div>
                <div ref={footerRef}>
                    <Footers found={found} sta={sta ?? {}} num={num} premiApp={premiApp} />
                </div>
            </div>

            <div className="invoicepreview">
                {pages.map((page, i) => (
                    <div className="pageinv" key={i}>
                        <div className="contentview">
                            <HeadersNew found={found}  />
                            <HeadersSecond locInv={locInv} found={found} sta={sta} inv={inv}  />
                            <BodyInvoice locInv={locInv} found={found} sta={sta} inv={inv}  chunk={page ?? []} isLast={i == pages.length - 1} premiApp={premiApp} />
                            <NotesFooter inv={inv} num={num} premiApp={premiApp} clas={clas} />
                        </div>
                        <Footers found={found} sta={sta ?? {}} num={num}  premiApp={premiApp} />
                    </div>
                ))}
            </div>
        </>
    );
}
export default MaintancInvCon;
